type AnalyticsPayload = Record<string, unknown>;

let sendEvent:
  | ((
      eventType: string,
      page?: string,
      metadata?: Record<string, unknown>,
    ) => void)
  | null = null;

export function registerTransport(sendFn: typeof sendEvent) {
  sendEvent = sendFn;
}

export function unregisterTransport() {
  sendEvent = null;
}

function isDebugEnabled(): boolean {
  if (typeof window === "undefined") return false;
  const envFlag = process.env.NEXT_PUBLIC_ANALYTICS_DEBUG;
  if (envFlag === "1" || envFlag === "true") return true;
  try {
    return window.localStorage.getItem("zom.analytics.debug") === "1";
  } catch {
    return false;
  }
}

export function trackEvent(event: string, payload: AnalyticsPayload = {}) {
  if (typeof window === "undefined") return;

  if (isDebugEnabled()) {
    if (sendEvent) {
      console.log("[analytics] trackEvent →", event, payload);
    } else {
      console.warn(
        `[analytics] trackEvent("${event}") dropped — no transport registered (AnalyticsProvider not mounted yet)`,
      );
    }
  }

  if (sendEvent) {
    try {
      sendEvent(event, undefined, payload);
    } catch (error) {
      if (isDebugEnabled()) {
        console.warn("[analytics] transport failed", error);
      }
    }
  }
}
